<div *ngIf="!loading" class="modal-header pb-0">
  <h1 class="modal-title" id="modal-basic-title">{{ (userToEdit ? 'contacts.contact-edit-modal.headerEdit' :
    'contacts.contact-add-modal.headerAdd') | translate }}
  </h1>
  <button class="cdx-button cdx-button--icon" aria-label="Close" (click)="close()">
    <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','times']"></fa-icon>
  </button>
</div>
<div *ngIf="!loading" class="modal-body">
  <form #f="ngForm" [formGroup]="signatoryAddForm">
    <div class="form-row">
      <div [ngClass]="{'has-error' : (fullName.invalid && (fullName.dirty || fullName.touched))}"
        class="form-group col-12">
        <cdx-label [options]="{label: 'fullName', labelFor: 'txtFullName', requirement: 'required' , tooltipMessage: this.signatureWarningLitmitCaracter ?  'businessError.signatureWarningLimitCaracter' : null} ">   </cdx-label>
        <input type="text" class="form-control" id="fullName" formControlName="fullName"
          placeholder="Ex.: Carla Machado">
        <cdx-helper *ngIf="(fullName.invalid && (fullName.dirty || fullName.touched))"
          [options]="{text: 'contacts.errors.name', hasError: true}"></cdx-helper>
      </div>
    </div>

    <div class="form-row">
      <div [ngClass]="{'has-error' : (mail.invalid && (mail.dirty || mail.touched))}" class="form-group col-12">
        <cdx-label [options]="{label: 'mail', labelFor: 'txtMail', requirement: 'required'}"></cdx-label>
        <input type="email" class="form-control" id="txtMail" formControlName="mail"
          placeholder="{{ 'mailExample' | translate }}">
        <cdx-helper *ngIf="(mail.invalid && (mail.dirty || mail.touched))"
          [options]="{text: 'contacts.errors.mail', hasError: true}"></cdx-helper>
      </div>
    </div>

    <div class="form-row mb-2" *ngIf="!hiddenSSN">
      <div [ngClass]="{'has-error' : (ssn.invalid && (ssn.dirty || ssn.touched))}"
        class="form-group col-12">
        <cdx-label
          [options]="{label: 'ssnUp', labelFor: 'txtSSN', requirement: 'optional', tooltipMessage: 'contacts.tooltip.ssn'}"></cdx-label>

        <input type="text" class="form-control" id="txtSSN" formControlName="ssn" [mask]="ssnMask" (input)="onSsnInput($event)"
          placeholder="000.000.000-00">
        <cdx-helper *ngIf="(ssn.invalid && (ssn.dirty || ssn.touched))"
          [options]="{text: 'contacts.errors.ssn', hasError: true}"></cdx-helper>
      </div>
    </div>  

    <cdx-divider *ngIf="isSignFreemium || !(isSendMessageWhatsappEnabled && !isSendWhatsapp)"></cdx-divider>
    
    <div class="form-group g-17 mb-2">
      <div class="form-row pointerMouse" *ngIf="!isSignFreemium && (!isSendMessageWhatsappEnabled || isSendWhatsapp)">
        <cdx-toggle-switch [toggledOn]="!isSignFreemium && isSendMessageWhatsappEnabled && isSendWhatsapp && acceptWhatsapp" (toggle)="changeAcceptWhatsapp($event)" [disabled]="!isSendMessageWhatsappEnabled">
        </cdx-toggle-switch>
        <cdx-label
          [options]="{
            label: 'contacts.acceptWhatsapp', 
            tooltipMessage: isSendMessageWhatsappEnabled ? 'contacts.acceptWhatsappTooltip' : 'contacts.sendMessageWhatsappDisabledTooltip',
            isDisabled: (!isSendMessageWhatsappEnabled || (isSendMessageWhatsappEnabled && !isSendWhatsapp)) ? true : false
          }">
        </cdx-label>
      </div>

      <div class="form-row helperDisabledWhatsapp mt-3" *ngIf="!isSignFreemium && !this.isSendMessageWhatsappEnabled">
        <fa-icon class="fa-fw" [icon]="['fas','crown']"></fa-icon>
        <span>{{ 'contacts.sendMessageWhatsappDisabled' | translate }}</span>
      </div>

      <div class="g-17" *ngIf="isSignFreemium">
        <div (click)="toastWhatsFree()" class="pointerMouse form-row mb-2">
          <cdx-toggle-switch [toggledOn]="acceptWhatsapp" (toggle)="changeAcceptWhatsapp($event)" [disabled]="true">
          </cdx-toggle-switch>
          <cdx-label
            [options]="{label: 'contacts.acceptWhatsapp', tooltipMessage: 'contacts.acceptWhatsappTooltip', isDisabled: true}" ></cdx-label>
        </div>

        <div class="helperDisabledWhatsapp form-row">
          <fa-icon class="fa-fw" [icon]="['fas','crown']"></fa-icon>
          <span>{{ 'contacts.acceptWhatsappSignFree' | translate }}</span>
        </div>
      </div>
      <div class="form-row">
        <div *ngIf="!isSignFreemium && isSendMessageWhatsappEnabled && isSendWhatsapp && acceptWhatsapp"
          [ngClass]="{'has-error' : (acceptWhatsapp && !phoneValid)}" class="col-12 mt-2">
          <cdx-label
            [options]="{label: 'contacts.phone', labelFor: 'telephone', requirement: 'required'}">
          </cdx-label>
          <app-intl-tel-input [id]="'telephone'"
            (phoneNumberChange)="phoneNumberChange($event)" [defaultValue]="defaultValuePhone"
            (isNumberValid)="isNumberValid($event)"></app-intl-tel-input>
          <cdx-helper *ngIf="(acceptWhatsapp && !phoneValid)"
            [options]="{text: 'contacts.errors.phone', hasError: true}"></cdx-helper>
        </div>
      </div>
    </div>
    <cdx-divider *ngIf="isSignFreemium || !(isSendMessageWhatsappEnabled && !isSendWhatsapp)"></cdx-divider>

    <div class="form-row" *ngIf="!isObserverOrAuthorizer">
      <div
        [ngClass]="{'has-error' : (signatureType.invalid && (signatureType.dirty || signatureType.touched ))}"
        class="form-group col-12">
        <cdx-label
          [options]="{label: 'contacts.signatureTypeText', labelFor: 'ddlSignatoryType', requirement: 'required'}"></cdx-label>
        <cdx-dropdown [options]="signatureTypeDropDown" id="signType" formControlName="signType"
          [selectedItem]="signatureType.value" (onSelectItem)="onSignatureTypeSelectItem($event)"></cdx-dropdown>
        <cdx-helper *ngIf="(signatureType.invalid && (signatureType.dirty || signatureType.touched ))"
          [options]="{text: 'contacts.errors.signatureType', hasError: true}"></cdx-helper>
          <a class="cdx-btn-link--xs" (click)="linkClicked()">{{'contacts.subscriberTypeTextHelper' | translate}}</a>
      </div>
    </div>

    <div class="form-row" *ngIf="!isObserverOrAuthorizer">
      <div
        [ngClass]="{'has-error' : (subscriberType.invalid && (subscriberType.dirty || subscriberType.touched))}"
        class="form-group col-12">
        <cdx-label
          [options]="{label: 'envelope.signatory.subscriberTypeText', labelFor: 'ddlSubscriberType', requirement: 'required'}"></cdx-label>
          <cdx-dropdown
          [options]="subscriberTypeDropDown"
          id="subType"
          [selectedItem]="subscriberType.value"
          (onSelectItem)="onSubscriberTypeSelectItem($event)"
          ></cdx-dropdown>
        <cdx-helper *ngIf="subscriberType.invalid && (subscriberType.dirty || subscriberType.touched)"
          [options]="{text: 'contacts.errors.subscriberType', hasError: true}"></cdx-helper>
      </div>
    </div>

    <div class="form-row" *ngIf="!isObserverOrAuthorizer && !isSignFreemium">
      <div class="form-group" style="width: 100%;">

        <cdx-label [options]="{label: 'contacts.segmentsContactsAddEdit'}"></cdx-label>
        <cdx-card-collapse [isCollapsed]="true" [isCardBox]="true">
          <div class="header align-items-center d-flex">
            <span>{{ "settings.tabs.segment" | translate | titlecase }}</span>
          </div>
          <div class="body">
            <div class="segments-container">
              <div class="segment-item col-12" (click)="onAllSegmentChecked()">
                <fa-icon class="fa-sm" [icon]="['fal','square']" *ngIf="!allSegments"></fa-icon>
                <fa-icon class="fa-sm" [icon]="['fas','check-square']" *ngIf="allSegments">
                </fa-icon><label>{{ "allSegments" | translate }}</label>
              </div>
              <div class="segments-container">
                <div class="segment-item col-6" *ngFor="let segment of segments" (click)="segmentChecked(segment)">
                  <fa-icon class="fa-sm" [icon]="['fal','square']" *ngIf="!segment.checked"></fa-icon>
                  <fa-icon class="fa-sm" [icon]="['fas','check-square']" *ngIf="segment.checked">
                  </fa-icon>
                  <label>{{ segment.name }}</label>
                </div>
              </div>
            </div>
            <cdx-helper *ngIf="!someSegmentSelected()"
              [options]="{text: 'contacts.errors.segment', hasError: true}"></cdx-helper>
          </div>
        </cdx-card-collapse>
      </div>
    </div>
  </form>
</div>
<div *ngIf="!loading" class="modal-footer">
  <div class="row">
    <button
      class="cdx-button cdx-button--tertiary ml-2"
      (click)="close()">
      <span class="cdx-button__text">{{ 'cancel' | translate | uppercase }}</span>
    </button>

    <button
      *ngIf="!isEditEnvelope"
      class="cdx-button cdx-button--primary ml-0"
      (click)="addSignatory(true)"
      [disabled]="!canSubmitSignatory">
      <span class="cdx-button__text">
        {{ userToEdit ? ('contacts.envelopeEdit.save' | translate | uppercase)
                     : ('contacts.contact-add-modal.headerAdd' | translate | uppercase) }}
      </span>
    </button>

    <div ngbDropdown *ngIf="isEditEnvelope" aria-haspopup="true" aria-expanded="false">
      <button
        class="cdx-button cdx-button--primary ml-0"
        ngbDropdownToggle
        [disabled]="!signatoryAddForm.valid">
        <span class="cdx-button__text">{{ (userToEdit ? 'edit' : 'insert') | translate | uppercase}}</span>
        <fa-icon class="fa-fw cdx-button__icon" [icon]="['fas','caret-down']"></fa-icon>
      </button>
      <div ngbDropdownMenu style="min-width: max-content; white-space: nowrap;">
        <button
          ngbDropdownItem
          (click)="addSignatory(false)">
            {{ 'contacts.envelopeEdit.saveJustInEnvelope' | translate }}
        </button>
        <button
          ngbDropdownItem
          (click)="addSignatory(true)">
          {{ userToEdit
            ? ('contacts.envelopeEdit.saveAndUpdateContact' | translate)
            : ('contacts.envelopeEdit.saveAndAddContact'    | translate) }}
        </button>
      </div>
    </div>
  </div>
</div>
